import React from 'react';
import Icon from '@/components/ui/AppIcon';
import Image from 'next/image';

interface Differentiator {
  icon: string;
  title: string;
  description: string;
}

interface WhyChooseUsProps {
  title: string;
  subtitle: string;
  differentiators: Differentiator[];
}

const WhyChooseUs: React.FC<WhyChooseUsProps> = ({
  title,
  subtitle,
  differentiators,
}) => {
  return (
    <section className="py-20 lg:py-28 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/assets/images/unnamed-1765472093097.jpg"
          alt="Professional legal office scene with wooden gavel and business professionals reviewing documents"
          fill
          className="object-cover"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/95 via-navy-dark/90 to-charcoal/85" />
      </div>
      
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(212,175,55,0.1),transparent_50%)]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-4">
            {title}
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            {subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {differentiators.map((diff, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 hover:bg-white/10 hover:border-accent transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-gold-dark rounded-lg flex items-center justify-center mb-6">
                <Icon name={diff.icon} size={28} className="text-primary" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-white mb-3">
                {diff.title}
              </h3>
              <p className="text-white/80 leading-relaxed">
                {diff.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;